module.exports = __webpack_public_path__ + "img/001.ddce27de.png";